import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { deleteShoppingCartItemsApi } from "api/shopping-cart/deleteShoppingCartItemsApi";
import { sendUpdateCartEvent } from "../../util/analytics/sendUpdateCartEvent";
import { hideLoader } from "../loader/hideLoader";
import { showLoader } from "../loader/showLoader";
import { refreshShoppingCart } from "./refreshShoppingCart";

export function removeShoppingCartItem(item: ICompactProduct) {
  return (dispatch: any, getState: any) => {
    dispatch(showLoader());
    const { selectedVehicle } = getState().garage;
    return deleteShoppingCartItemsApi(item.sku).then(() => {
      sendUpdateCartEvent({ ...item, quantity: 0 }, selectedVehicle);
      dispatch(hideLoader());
      dispatch(refreshShoppingCart());
    });
  };
}
